import { render } from "./Eva new pharma factory of HORUS.vue?vue&type=template&id=0b0e3850&scoped=true"
const script = {}

import "./Eva new pharma factory of HORUS.vue?vue&type=style&index=0&id=0b0e3850&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0b0e3850"

export default script